export default function NoticeBar() {
  return (
    <div className="w-full bg-primary-600 text-background-50">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-start gap-1 px-4 py-2 text-xs sm:flex-row sm:items-center sm:justify-between md:px-6">
        <p className="flex items-center gap-2">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-megaphone-line text-sm"></i>
          </span>
          本页仅提供地址导航与访问指引，请认准上方的官方线路，避免进入仿冒站点。
        </p>
        <p className="flex items-center gap-2 text-background-100/90">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-refresh-line text-sm"></i>
          </span>
          线路最近更新：2026-10-10
        </p>
      </div>
    </div>
  );
}